var map = {
	"./open-sans-v16-latin-600.woff": 39,
	"./open-sans-v16-latin-600.woff2": 40,
	"./open-sans-v16-latin-700.woff": 41,
	"./open-sans-v16-latin-700.woff2": 42,
	"./open-sans-v16-latin-800.woff": 43,
	"./open-sans-v16-latin-800.woff2": 44,
	"./open-sans-v16-latin-italic.woff": 45,
	"./open-sans-v16-latin-italic.woff2": 46,
	"./open-sans-v16-latin-regular.woff": 47,
	"./open-sans-v16-latin-regular.woff2": 48
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38;